import { useState } from "react";
import * as S from "./styles";
import illustrationManual from '../../assets/illustration-manual.png'
import Button from "../../components/button";
import { useScreenSize } from "../../hooks/useScreenSize";
import ReactHtmlParser from "react-html-parser";

import Modal from "../../components/modal";


const SectionManual = () => {
  const dimension = useScreenSize();
  const KEY_STORAGE_LOG = '@ESTACIO_FORTNITE';
  const URL_EBOOK = "https://portal.estacioprd.net/documents/20124/1460081/manual-enemverso.pdf/";

  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);

  const onCloseModal = () => {
    setOpenModal(false);
  };

  const onSetState = () => {
    const user = localStorage.getItem(KEY_STORAGE_LOG) || null;
    const userData = JSON.parse(user);

    if (userData) {
      window.open(URL_EBOOK, "_blank");
    } else {
      setModalMessage(`<p>Ops, para ter acesso ao e-book é preciso realizar o cadastro ou o login no enemverso.</p>`);
      setOpenModal(true);
    }
  };

  return (
    <S.SectionManual id='toManual' data-section="section_manual">
      <div className='container'>
        <div className="list-manual">
          <h2>Inventário de conhecimento para platinar o ENEM</h2>
          <p>
            Baixe os materiais e aumente seus pontos de habilidades no ENEM com
            as melhores dicas e conteúdos para potencializar sua preparação.
          </p>
          <ul className="list">
            <li>
              <h3>Top 20 temas mais explorados na prova</h3>
              <p>Domine os principais assuntos do exame e não caia em armadilhas.</p>
            </li>
            <li>
              <h3>O multiverso do relaxamento para brilhar na prova</h3>
              <p>Dicas para manter a calma e derrotar os inimigos que atrapalham sua concentração.</p>
            </li>
            <li>
              <h3>Dicas universais para mandar bem no ENEM</h3>
              <p>Descubra os segredos para fortalecer a sua jornada no ENEM e subir de nível.</p>
            </li>
          </ul>

          {dimension.width >= 1024 && (
            <Button
              label="BAIXAR CONTEÚDO"
              fontSize={23}
              height='86'
              width={414}
              padding={0}
              weight={900}
              action={() => onSetState()}
              hoverColor="#18B7EF"
              dataElement="button_baixar-conteudo"
            />
          )}
        </div>

        <img className="illustration-manual" src={illustrationManual} alt="Ilustração do manual do enemverso" />
        {dimension.width < 1024 && (
          <Button
            label="BAIXAR CONTEÚDO"
            fontSize={18}
            height='73'
            width={234}
            padding={0}
            weight={900}
            action={() => onSetState()}
            hoverColor="#18B7EF"
            dataElement="button_baixar-conteudo"
          />
        )}
      </div>

      <Modal isOpen={openModal} onClose={onCloseModal}>
        {ReactHtmlParser(modalMessage)}
      </Modal>

    </S.SectionManual>
  );
};

export default SectionManual;
